import { useState } from 'react';
import { withRouter } from 'react-router-dom';
import logo from '../../../assets/images/logos/powertrack.png';
import AlertService from '../../../components/SweetAlert';
import ToastUtil from '../../../components/ToastNotification/ToastUtil';
import { config } from '../../../config/index';
const { API_URL, ASSOCIATE_URL } = config;

const ForgotPassword = ({ history, match: { params } }) => {
  const type = params.type;
  const [email, setEmail] = useState('');

  const emailHandler = (e) => setEmail(e.target.value);

  const submitFormHandler = async (e) => {
    e.preventDefault();

    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to reset your password?'
      )
    ) {
      try {
        let response = await fetch(
          `${API_URL}/${type}/reset-password/request`,
          {
            mode: 'cors',
            method: 'POST',
            body: JSON.stringify({ email }),
            withCredentials: true,
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json; charset=utf-8',
            },
          }
        );

        let responseData = await response.json();

        if (response.ok) {
          ToastUtil.success(responseData.message);
          if (type === 'associate') {
            window.location.href = ASSOCIATE_URL;
          } else {
            history.push('/');
          }
        } else {
          ToastUtil.error(responseData.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <div
      className="d-flex flex-column text-center align-items-center justify-content-center"
      style={{ height: '100vh' }}
    >
      <div
        className="container"
        style={{ position: 'relative', height: '75%', width: '350px' }}
      >
        <div className="mb-4 pb-2 mx-auto" style={{ width: '200px' }}>
          <img src={logo} style={{ width: '200px' }} alt="" />
        </div>
        <h5>Reset Password</h5>
        <form onSubmit={(e) => submitFormHandler(e)}>
          <input
            className="form-control mt-4 mb-2"
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => emailHandler(e)}
          />
          <button
            type="submit"
            className="btn btn-brand btn-block mt-4"
            style={{ width: '100%' }}
          >
            Send
          </button>
        </form>
      </div>
    </div>
  );
};

export default withRouter(ForgotPassword);
